(() => {
  const root = document.querySelector('.archive-v1');
  if (!root) return;

  const next = root.querySelector('[data-archive-next]');
  const previous = root.querySelector('[data-archive-previous]');
  const worksToggle = root.querySelector('[data-archive-works-toggle]');
  const worksMenu = root.querySelector('[data-archive-works-menu]');

  if (worksToggle && worksMenu) {
    const worksContextActive = worksToggle.hasAttribute('data-archive-works-context-active');
    const seriesHome = worksToggle.dataset.archiveSeriesHome || '/';
    const seriesIndexUrl = new URL(seriesHome, window.location.origin);
    const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
    const isSeriesIndex =
      root.dataset.archivePage === 'index' &&
      normalizePath(window.location.pathname) === normalizePath(seriesIndexUrl.pathname);
    const setWorksMenu = (open) => {
      worksMenu.hidden = !open;
      worksToggle.setAttribute('aria-expanded', String(open));
      worksToggle.classList.toggle('is-active', open || worksContextActive);
    };
    if (isSeriesIndex && new URLSearchParams(window.location.search).get('series') === 'open') {
      setWorksMenu(true);
    }
    worksToggle.addEventListener('click', () => {
      if (!isSeriesIndex) {
        seriesIndexUrl.searchParams.set('series', 'open');
        window.location.assign(seriesIndexUrl.toString());
        return;
      }
      setWorksMenu(worksMenu.hidden);
    });
  }

  if (root.dataset.archivePage === 'product') {
    document.addEventListener('keydown', (event) => {
      if (event.target.matches('input, select, textarea, button')) return;
      if (event.key === 'ArrowRight' && next) window.location.assign(next.href);
      if (event.key === 'ArrowLeft' && previous) window.location.assign(previous.href);
    });
  }

  root.querySelectorAll('[data-archive-variant]').forEach((variantSelect) => {
    const price = variantSelect.closest('.archive-acquire__panel')?.querySelector('[data-archive-price]');
    if (!price) return;
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (option?.dataset.price) price.textContent = option.dataset.price;
    });
  });

  const signup = root.querySelector('[data-archive-signup]');
  const signupForm = root.querySelector('[data-archive-signup-form]');
  const signupClose = root.querySelector('[data-archive-signup-close]');
  const signupError = root.querySelector('[data-archive-signup-error]');
  const signupFormState = root.querySelector('[data-archive-signup-form-state]');
  const signupThanks = root.querySelector('[data-archive-signup-thanks]');
  const signupStorage = {
    pages: 'archiveSignupPages',
    dismissed: 'archiveSignupDismissedAt',
    subscribed: 'archiveSignupSubscribed'
  };
  const thirtyDays = 30 * 24 * 60 * 60 * 1000;

  const canShowSignup = () => {
    if (!signup || localStorage.getItem(signupStorage.subscribed) === 'true') return false;
    const dismissedAt = Number(localStorage.getItem(signupStorage.dismissed) || 0);
    return !dismissedAt || Date.now() - dismissedAt >= thirtyDays;
  };

  const eligiblePage = root.dataset.archivePage === 'collection' || root.dataset.archivePage === 'product';
  if (signup && eligiblePage) {
    let viewedPages = [];
    try {
      viewedPages = JSON.parse(localStorage.getItem(signupStorage.pages) || '[]');
      if (!Array.isArray(viewedPages)) viewedPages = [];
    } catch (_error) {
      viewedPages = [];
    }
    const pageKey = `${root.dataset.archivePage}:${window.location.pathname}`;
    if (!viewedPages.includes(pageKey)) viewedPages.push(pageKey);
    localStorage.setItem(signupStorage.pages, JSON.stringify(viewedPages));
    if (viewedPages.length >= 3 && canShowSignup()) {
      window.setTimeout(() => {
        signup.hidden = false;
        signup.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      }, 450);
    }
  }

  signupClose?.addEventListener('click', () => {
    localStorage.setItem(signupStorage.dismissed, String(Date.now()));
    signup.hidden = true;
  });

  signupForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const email = signupForm.elements.EMAIL.value.trim();
    if (!email || !signupForm.elements.EMAIL.checkValidity()) {
      signupError.textContent = 'Please enter a valid email address.';
      signupError.hidden = false;
      signupForm.elements.EMAIL.focus();
      return;
    }

    signupError.hidden = true;
    const callbackName = `archiveSignup_${Date.now()}`;
    const params = new URLSearchParams(new FormData(signupForm));
    params.set('c', callbackName);
    const script = document.createElement('script');
    const cleanup = () => {
      script.remove();
      delete window[callbackName];
    };
    window[callbackName] = (response) => {
      const message = String(response?.msg || '').replace(/<[^>]*>/g, '');
      if (response?.result === 'success' || /already subscribed/i.test(message)) {
        localStorage.setItem(signupStorage.subscribed, 'true');
        signupFormState.hidden = true;
        signupThanks.hidden = false;
        window.setTimeout(() => { signup.hidden = true; }, 2200);
      } else {
        signupError.textContent = message || 'Please try again.';
        signupError.hidden = false;
      }
      cleanup();
    };
    script.onerror = () => {
      signupError.textContent = 'Please try again.';
      signupError.hidden = false;
      cleanup();
    };
    script.src = `https://StudioDonovan.us10.list-manage.com/subscribe/post-json?u=9204768d81d289875755a79a7&id=fc9ec1f905&f_id=007f48e4f0&${params.toString()}`;
    document.body.appendChild(script);
  });
})();
